'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#referer') && window.location.href.indexOf('/r/gdi') > 0) {
      $(
        '.main-nav__register-button, main-nav__register-button-mobile, .primary-marketing-button--header, .df-features-list__item--button, .primary-marketing-button--easy-to-use, .tour__seamless-button'
      ).attr('href', '/designer/register?rfsn=6095552.5d86e8');

      const isUrlUpdated = false;
      const updateUrl = (isUrlUpdated) => {
        if (!isUrlUpdated) {
          setTimeout(() => {
            updateUrl(isUrlUpdated);
          }, 500);
        }
      };
      updateUrl(isUrlUpdated);
    }

    // launch video modal on click
    $('.case-testimonies__image').on('click', function (e) {
      e.preventDefault();
      showCaseTestimonyVideo($(this).attr('href'));
    });

    // launch video modal on videos pages for certain url hashes
    if (location.hash.substring(0, 8) === '#video__') {
      showCaseTestimonyVideo(location.hash);
    }
  });

  // Fade in images on scroll in
  function showOnScrloo(el) {
    const windowHeight = $(window).height();
    $(el).each(function () {
      const thisPos = $(this).offset().top;
      const topOfWindow = $(window).scrollTop();
      if (topOfWindow + windowHeight - 200 > thisPos) {
        $(this).css('opacity', 1);
      }
    });
  }

  $(document).ready(function () {
    $('.board-examples__jcarousel').jcarousel();

    $('.board-examples__prev')
      .on('jcarouselcontrol:active', (e) => {
        $(e.target).removeClass('board-examples__prev--inactive');
      })
      .on('jcarouselcontrol:inactive', (e) => {
        $(e.target).addClass('board-examples__prev--inactive');
      })
      .jcarouselControl({
        target: '-=1',
      });
    $('.board-examples__next')
      .on('jcarouselcontrol:active', (e) => {
        $(e.target).removeClass('board-examples__next--inactive');
      })
      .on('jcarouselcontrol:inactive', (e) => {
        $(e.target).addClass('board-examples__next--inactive');
      })
      .jcarouselControl({
        target: '+=1',
      });

    const pageNames = [
      'Mood Boards',
      'Floor Plans',
      '3D Renderings',
      'Product Clipper',
      'Product Catalog',
      'Client Portal',
    ];

    $('.board-examples__pagination')
      .on('jcarouselpagination:active', 'a', (e) => {
        $(e.target).addClass('active');
      })
      .on('jcarouselpagination:inactive', 'a', (e) => {
        $(e.target).removeClass('active');
      })
      .jcarouselPagination({
        item(page) {
          return `<a href="#${page}" class="board-examples__page board-examples__page--${page}">${
            pageNames[page - 1]
          }</a>`;
        },
      });
    $('.board-examples__jcarousel').jcarousel('scroll', 1);
  });

  $(document).ready(function () {
    $(document).on(
      'click',
      '.board-examples__pagination, .board-examples__prev, .board-examples__next',
      () => {
        const cIndex = $('.board-examples__pagination .active').text();
        $('.board-examples__jcarousel img').addClass('inactive');
        $('.board-examples__jcarousel .board-examples__panel').addClass(
          'board-examples__panel--inactive'
        );
        $('.board-examples__jcarousel ul li').eq(cIndex).find('img').removeClass('inactive');
        $('.board-examples__jcarousel ul li')
          .eq(cIndex)
          .find('.board-examples__panel')
          .removeClass('board-examples__panel--inactive');
        $('.board-examples__jcarousel-item img').addClass('inactive');
        $('.board-examples__jcarousel').jcarousel('target').find('img').removeClass('inactive');
      }
    );
  });

  $(document).on('click', '.board-examples__jcarousel-item', (e) => {
    $('.board-examples__pagination').find('a').eq($(e.target).closest('li').index()).click();
  });

  $(document).ready(() => {
    showOnScrloo('.tour__image, .tour__df-image, .df-pros__pro');
  });
  $(window).scroll(() => {
    showOnScrloo('.tour__image, .tour__df-image, .df-pros__pro');
  });

  $('.tour__testimonials').jcarousel({ wrap: 'circular' });
  $('.tour__testimonial-prev').jcarouselControl({ target: '-=1' });
  $('.tour__testimonial-next').jcarouselControl({ target: '+=1' });

  $(document).mouseleave(function () {
    if (!localStorage.ny_2021_exit_modal_shown) {
      localStorage.ny_2021_exit_modal_shown = 1;
      $('.modal--hp-exit-promo').modal();
    }
  });

  function showCaseTestimonyVideo(videoID) {
    const $videoModal = $(videoID);

    if ($videoModal.find('iframe').length === 0) {
      const iframeURL = $videoModal.attr('data-youtube-url');
      const $videoModalIframe = $('<iframe>')
        .attr('class', 'video-modal__iframe')
        .attr('src', iframeURL)
        .attr('frameborder', '0')
        .attr('allowfullscreen', '');

      $videoModal.append($videoModalIframe);
    }

    $videoModal.modal();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const lazyImages = document.querySelectorAll('.lazy-bg, .lazy-bg-before, .lazy-bg-after');
    const imageObserver = new IntersectionObserver((entries, _observer) => {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const image = entry.target;
          image.classList.remove('lazy-bg', 'lazy-bg-before', 'lazy-bg-after');
          imageObserver.unobserve(image);
        }
      });
    });

    lazyImages.forEach((image) => {
      imageObserver.observe(image);
    });
  });

  if ($('body').is('#lml-page-thank-you')) {
    // add source of the video with autoplay parameter when mdal opens
    // and remove it after modal closes
    // to previent autoplay triggering in the closed modal
    $(document).on('click', '.how-it-works-video', () => {
      $('#90-seconds')
        .find('.video-modal__iframe')
        .attr('src', 'https://www.youtube.com/embed/K4rM9dQtt8Y?rel=0&autoplay=1');
    });
    $(document).on($.modal.CLOSE, '#90-seconds', () => {
      $('#90-seconds').find('.video-modal__iframe').attr('src', '');
    });

    const updateImage = (featuresHighlight, index) => {
      const designImages = [
        'features-highlight__image--design1',
        'features-highlight__image--design2',
        'features-highlight__image--design3',
        'features-highlight__image--design4',
      ];
      const collaborateImages = [
        'features-highlight__image--collaborate1',
        'features-highlight__image--collaborate2',
        'features-highlight__image--collaborate3',
        'features-highlight__image--collaborate4',
      ];
      const manageImages = [
        'features-highlight__image--manage1',
        'features-highlight__image--manage2',
        'features-highlight__image--manage3',
        'features-highlight__image--manage4',
      ];
      const getPaidImages = [
        'features-highlight__image--get-paid1',
        'features-highlight__image--get-paid2',
        'features-highlight__image--get-paid3',
        'features-highlight__image--get-paid4',
      ];
      const kind = featuresHighlight.closest('.features-highlight').data('kind');
      const imageContainer = featuresHighlight
        .closest('.features-highlight__breakdown')
        .find('.features-highlight__image');

      imageContainer.removeClass().addClass('features-highlight__image');
      if (kind === 'design') {
        imageContainer.addClass(designImages[index]);
      } else if (kind === 'collaborate') {
        imageContainer.addClass(collaborateImages[index]);
      } else if (kind === 'manage') {
        imageContainer.addClass(manageImages[index]);
      } else if (kind === 'get-paid') {
        imageContainer.addClass(getPaidImages[index]);
      }
    };

    $(document).on('click', '.features-highlight-list__feature', (e) => {
      updateImage($(e.currentTarget), $(e.currentTarget).index());

      $(e.target)
        .closest('.features-highlight__breakdown')
        .addClass('features-highlight__breakdown--paused')
        .find('.features-highlight-list__feature')
        .removeClass('features-highlight-list__feature--active');

      $(e.target)
        .closest('.features-highlight__breakdown')
        .find('.features-highlight-list__progress-bar')
        .remove();

      $(e.target)
        .closest('.features-highlight-list__feature')
        .addClass('features-highlight-list__feature--active');

      $(e.currentTarget)
        .closest('.features-highlight-list')
        .find($('.features-highlight-list__pagination-item'))
        .removeClass('features-highlight-list__pagination-item--active');

      $(e.currentTarget)
        .closest('.features-highlight-list')
        .find($('.features-highlight-list__pagination-item'))
        .eq($(e.currentTarget).index())
        .addClass('features-highlight-list__pagination-item--active');

      return false;
    });

    $(document).on('click', '.features-highlight-list__pagination-item', (e) => {
      $(e.target)
        .closest('.features-highlight-list__pagination')
        .find('.features-highlight-list__pagination-item')
        .removeClass('features-highlight-list__pagination-item--active');
      $(e.target).addClass('features-highlight-list__pagination-item--active');
      $(e.target)
        .closest('.features-highlight-list')
        .find('.features-highlight-list__feature')
        .eq($(e.target).index())
        .click();
    });

    $(window).scroll(() => {
      const featuresHighlights = Array.from(
        document.querySelectorAll('.features-highlight__breakdown')
      );

      featuresHighlights.forEach((featuresHighlight) => {
        const designDistanceToTopOfWindow = featuresHighlight.getBoundingClientRect().top;
        const isInView = designDistanceToTopOfWindow - $(window).height() < 0;
        const isNotEnabled = !featuresHighlight.dataset.enabled;
        if (isInView && isNotEnabled) {
          animateFeatures(featuresHighlight);
        }
      });
    });

    const animateFeatures = (featuresHighlight) => {
      featuresHighlight.dataset.enabled = 'true';
      featuresHighlight
        .querySelector('.features-highlight-list__feature')
        .classList.add('features-highlight-list__feature--active');

      setInterval(() => {
        const $currentActive = $(featuresHighlight).find(
          '.features-highlight-list__feature--active'
        );

        let $nextActive;
        if ($currentActive.next().hasClass('features-highlight-list__feature-button')) {
          $nextActive = $(featuresHighlight).find('.features-highlight-list__feature').first();
        } else {
          $nextActive = $currentActive.next('.features-highlight-list__feature');
        }
        if ($(featuresHighlight).is(':not(.features-highlight__breakdown--paused)')) {
          $currentActive.removeClass('features-highlight-list__feature--active');
          $nextActive.addClass('features-highlight-list__feature--active');
          updateImage($(featuresHighlight), $nextActive.index());

          $(featuresHighlight)
            .find($('.features-highlight-list__pagination-item'))
            .removeClass('features-highlight-list__pagination-item--active');

          $(featuresHighlight)
            .find($('.features-highlight-list__pagination-item'))
            .eq($nextActive.index())
            .addClass('features-highlight-list__pagination-item--active');
        }
      }, 6000);
    };
  }

  if (document.getElementsByClassName('df-rating-band').length > 0) {
    $(window).scroll(() => {
      // animate scrollbar when it comes into view
      const designDistanceToTopOfWindow = document
        .getElementsByClassName('df-rating-band__bar-container')[0]
        .getBoundingClientRect().top;
      if (designDistanceToTopOfWindow - $(window).height() < 0) {
        if (!$('.df-rating-band__bar').hasClass('df-rating-band__bar--full')) {
          setInterval(() => {
            if ($('.df-rating-band__rating-value--recommend').text() !== '94%') {
              const value = parseInt($('.df-rating-band__rating-value--recommend').text());
              $('.df-rating-band__rating-value--recommend').text(`${value + 4}%`);
            }
          }, 70);
        }
        $('.df-rating-band__bar').addClass('df-rating-band__bar--full');
      }
    });
  }

  $(document).on('click', '.jump-links__link', (e) => {
    const targetId = $(e.target).attr('href');
    const headerHeight = $('.header').first().outerHeight() || 0;
    const scrollPosition = $(`${targetId}`).offset().top - headerHeight;

    window.scroll({
      top: scrollPosition,
      behavior: 'smooth',
    });
    return false;
  });

  $(document).on($.modal.OPEN, '#video__see-demo', (e) => {
    $(e.target)
      .find('.schedule-demo-modal__video-iframe')
      .attr('src', 'https://www.youtube.com/embed/e8parj12atM?rel=0');
  });

  $('#designfiles-demo-form').on('submit', function (e) {
    e.preventDefault();

    const formAction = $(this).attr('action');
    const name = $(e.target).find('input[name="designfiles_demo[name]"]').val();
    const email = $(e.target).find('input[name="designfiles_demo[email]"]').val();
    const question = $(e.target).find('textarea[name="designfiles_demo[question]"]').val();
    let url = formAction + '?name=' + name + '&email=' + email;

    if (question) {
      url += '&a1=' + question;
    }

    window.location.href = url;
  });

  $(document).on('click', '.contest-banner__close', () => {
    $('.contest-banner').hide();
    document.cookie =
      'signatureStyleShowcaseContestBanner=true; path=/; max-age=' + 60 * 60 * 24 * 365;

    return false;
  });
});
